import {
  FileReportUploadResponse,
  FileReportValidationStatusEnum,
} from '@fora-monorepo/employer-my-pages-common/types';
import { Feedback, Text } from '@foradevelopment/fora-ui';

type FileReportStatusCardProps = {
  fileReport: FileReportUploadResponse | null;
};

export const FileReportStatusCard = ({ fileReport }: FileReportStatusCardProps) => {
  if (fileReport?.fileReportStatus === FileReportValidationStatusEnum.WITH_WARNINGS) {
    return (
      <Feedback type="warning" negativeSideMargins={true} marginBottom={40} iconAbove>
        {fileReport.warnings?.map((warning, i) => (
          <Text key={i} size="small">
            {warning.warningText}
          </Text>
        ))}
      </Feedback>
    );
  }

  if (fileReport?.fileReportStatus === FileReportValidationStatusEnum.WITH_ERRORS) {
    return (
      <Feedback type="error" negativeSideMargins={true} marginBottom={40} iconAbove>
        {fileReport.formattedErrorMessages?.map((error, i) => (
          <Text key={i} size="small">
            {error}
          </Text>
        ))}
      </Feedback>
    );
  }
  return null;
};
